import React from 'react';
import './upcomingEventsStyles.scss';
import moment from 'moment';
import config from 'config';

let request;

class UpcomingEventsHorizontal extends React.Component {

  constructor(props) {
    super(props);
    this.props = props;
    let calendars = this.props.section.prop('calendars');
    let options = this.props.section.prop('upcoming_events_options');
    this.state = {
      calendarEvents: []
    };
    this.API_KEY = 'AIzaSyD0iq6kqEnh8mr1-42nAudojdElsGTRte0';
    import('superagent').then((mod) => {
      request = mod.default;
      calendars.forEach((calendar) => {
        this.getEvents(calendar.id, options.daysInAdvance, options.maxEvents, calendar.color, (events) => {
          this.state.calendarEvents.push(events);
          this.forceUpdate();
        });
      });
    });
    this.sortEvents = this.sortEvents.bind(this);
    this.getEvents = this.getEvents.bind(this);
  }

  isMidnight(m) {
    return m.minutes() + m.hours() * 60 === 0;
  }

  getEvents(calendarID, daysInAdvance, maxEvents, eventColor, callback) {
    let now = moment();
    const earliestDay = now.format();
    const lastDay = now.add(daysInAdvance, 'days').format();
    if (calendarID) {
      request
        .get(config.API_ROOT + `/calendar-proxy/${encodeURIComponent(calendarID)}/events?key=${this.API_KEY}&singleEvents=True` + '&timeMin=' + earliestDay + '&timeMax=' + lastDay)
        .end((err, resp) => {
          if (!err) {
            let events = [];
            JSON.parse(resp.text).items.map((event) => {
              const startDate = event.start.dateTime || event.start.date;
              const endDate = event.end.dateTime || event.end.date;
              let startMoment = moment(startDate);
              let endMoment = moment(endDate);
              const allDayEvent = event.end.date && typeof event.end.dateTime === 'undefined';

              if (this.props.section.prop('calendar_options') && this.props.section.prop('calendar_options').localTimezone) {
                startMoment = startMoment.tz(FW.store.get('customer').get('timezone'));
                endMoment = endMoment.tz(FW.store.get('customer').get('timezone'));
              }

              if (this.isMidnight(endMoment) && allDayEvent) {
                endMoment = endMoment.subtract('d', 1);
              }

              let startTime, endTime;
              if (startMoment.day() !== endMoment.day()) {
                startTime = startMoment.format('MMM Do, LT');
                endTime = endMoment.format('MMM Do, LT');
              } else {
                startTime = startMoment.format('h:mm a');
                endTime = endMoment.format('h:mm a');
              }
              let start = startDate.includes('T')
                ? startDate.split('T')[0]
                : startDate;
              let end = startDate.includes('T')
                ? startDate.split('T')[0]
                : startDate;
              let specialDuration = allDayEvent ? 'All day event' : <span>
                    Start: {startTime}<br />
                    End: {endTime}
                  </span>;
              events.push({
                start,
                end,
                startTime,
                endTime,
                title: event.summary,
                description: event.description,
                endMoment,
                startMoment,
                location: event.location,
                color: eventColor,
                specialDuration
              });
            });
            events = this.sortEvents(events);
            callback(events);
          }
        });
    }
  }

  sortEvents(events) {
    return events.sort((e, e2) => {
      return e.startMoment.isSameOrAfter(e2.startMoment) ? 1 : -1;
    });
  }

  render() {
    const options = this.props.section.prop('upcoming_events_options');
    const onEmpty = options.onEmpty;
    const showLocation = options.showLocation;
    const showDescription = options.showDescription;
    const font = options.font;

    const maxEvents = options.maxEvents;
    const chronologicalEvents = this.sortEvents([].concat.apply([], this.state.calendarEvents)).slice(0, maxEvents);

    const style = {
      color: options.color || '#000',
    };
    if (font && font !== 'default')
      style.fontFamily = font;

    const eventComponents = chronologicalEvents.map((event, i) => {
      return <div key={`event-${i}`} id={`event-${i}`} className={'event col-md-4'} style={{borderBottom: 'none'}}>
        <div className={'col-md-4'} style={{textAlign: 'right', padding: 0}}>
          {/*If the event spans multiple days, show start and end days*/}
          {event.startMoment.date() === event.endMoment.date() ?
            <p className={'eventDay'}>{event.startMoment.date()}</p>
            : <p className={'eventDay multipleDays'}>{event.startMoment.date()}-{event.endMoment.date()}</p>}
          {/*If the event spans multiple days, show start and end months if they're different*/}
          <p className="eventDayName">{event.startMoment.format('ddd')}</p>
          {event.startMoment.format('MMMM') === event.endMoment.format('MMMM') ?
            <p className={'eventMonth'}>{event.startMoment.format('MMMM')}</p>
            : <p
              className={'eventMonth multipleMonths'}>{event.startMoment.format('MMMM')}-{event.endMoment.format('MMMM')}</p>}
        </div>
        <div className={'col-md-8'} style={{textAlign: 'left'}}>
          <h3 className={'eventTitle'} style={{color: event.color}}>{event.title}</h3>
          {showDescription ?
            <p className={'eventDescription'} dangerouslySetInnerHTML={{__html: event.description}}></p> : null}
          {showLocation && event.location ? <p className={'eventLocation'}>Location: {event.location}</p> : null}
          {/*If the event spans multiple days, don't show the start and end time*/}
          {event.startMoment.date() === event.endMoment.date() || event.specialDuration ?
            <p
              className={'eventDuration'}>{event.specialDuration || (event.startTime + ' to ' + event.endTime)}</p> : null}
        </div>
      </div>;
    });

    let i;
    let rows = [];
    for (i = 0; i <= eventComponents.length; i = i + 3) {
      rows.push(<div className="row" key={i} style={{borderBottom: '3px dotted #aaa', paddingBottom: 10, paddingTop: 10}}>
        {eventComponents[i]}
        {eventComponents[i + 1]}
        {eventComponents[i + 2]}
      </div>);
    }

    const emptyFill = chronologicalEvents.length === 0 && onEmpty !== 'hide' ? <h3>No Events</h3> : null;

    return (
      <div style={style} className={'col-md-12 eventsContainer'}>
        {options.sectionTitle && (chronologicalEvents.length !== 0 || onEmpty !== 'hide') ? <h2 className={'upcomingEventsTitle'}>{options.sectionTitle}</h2> : null}
        {rows}
        {emptyFill}
      </div>
    );
  }

}

export default UpcomingEventsHorizontal;
